<template>
    <b-modal v-if="carPackage" v-model="shown" :title="$t('cars.search.quote.modalTitle')">
        <div class="form-group">
            <label for="pickup" class="form-control-label">
                {{ $t('cars.search.quote.pickup') }}
            </label>
            <input type="text" id="pickup" disabled :value="pickupString" class="form-control">
        </div>
        <div class="form-group">
            <label for="return" class="form-control-label">
                {{ $t('cars.search.quote.return') }}
            </label>
            <input type="text" id="return" disabled :value="returnString" class="form-control">
        </div>
        <div class="form-group">
            <label for="vendor" class="form-control-label">
                {{ $t('cars.search.quote.supplier') }}
            </label>
            <input type="text" id="vendor" disabled :value="carPackage.vendor.shortName" class="form-control">
        </div>
        <div class="form-group">
            <label for="vehicle" class="form-control-label">
                {{ $t('cars.search.quote.vehicle') }}
            </label>
            <input type="text" id="vehicle" disabled :value="carPackage.vehicle.model" class="form-control">
        </div>
        <div class="form-group">
            <label for="customer" class="form-control-label">
                {{ $t('cars.search.quote.customer') }}
            </label>
            <input type="text" id="customer" class="form-control" v-model="customer">
        </div>
        <div class="form-group">
            <label for="notes" class="form-control-label">
                {{ $t('cars.search.quote.notes') }}
            </label>
            <textarea id="notes" class="form-control" v-model="notes"></textarea>
        </div>
        <template slot="modal-footer">
            <b-btn v-if="submitting" variant="secondary">i.fa.fa-spinner.fa-pulse</b-btn>
            <b-btn v-else variant="primary" @click="handleSubmit">{{ $t('cars.search.quote.submit') }}</b-btn>
        </template>
    </b-modal>
</template>

<script>
    import Qs from 'qs';
    export default {
        name: 'QuoteModal',
        data() {
            return {
                shown: false,
                submitting: false,
                carPackage: null,
                customer: '',
                notes: '',
                errorMessage: null
            };
        },
        computed: {
            pickupString() {
                return this.$t('cars.search.quote.location', {
                    location: this.carPackage.pickupLocation.name,
                    date: moment(this.carPackage.pickupDate).format(this.$t('format.dateTimeLong'))
                });
            },
            returnString() {
                return this.$t('cars.search.quote.location', {
                    location: this.carPackage.returnLocation.name,
                    date: moment(this.carPackage.returnDate).format(this.$t('format.dateTimeLong'))
                });            }
        },
        methods: {
            quotePackage(carPackage) {
                this.carPackage = carPackage;
                this.shown = true;
                this.errorMessage = null;
            },
            handleSubmit() {
                axios.post(window.env.baseUri + 'quote/save', Qs.stringify({
                    type: 'car',
                    search_id: this.carPackage.searchId,
                    package_id: this.carPackage.packageId,
                    customer_name: this.customer,
                    notes: this.notes
                })).then((response) => {
                    this.submitting = false;
                    if (!response.data.success) {
                        this.errorMessage = response.data.message;
                        return;
                    }

                    this.shown = false;
                });
            }
        }

    };
</script>

<style scoped>

</style>